import LordIcon from "../ui/LordIcon";
import {Colors} from "../theme";
import {useTranslation} from "react-i18next";
import EventEntry from "./EventsEntryEdit";
import {integerValidate} from "../../helpers/validate";
import React, {useEffect, useReducer} from "react";
import {v4 as uuidv4} from "uuid";
import _ from "lodash";
import {diffTime} from "../../pages/roles/admin/PageContent/Sales/helpers/func_helpers";
import {isFreeEventDateAPI} from "../../services/api/calculator";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {
	eventDetailUnit,
	eventsReducer,
	INITIAL_STATE
} from "../../pages/roles/admin/PageContent/Projects/Projects/current/ProjectCurrentEventsReducer";
import {getEventsDataSetAPI, saveEventsAPI} from "../../services/api/projectCurrent";
import {EventsTypesCount} from "./calculator_components/EventsTypesCount";
import DarkCard from "../card/DarkCard";
import {Button} from "../ui/Button";
import PopupForm from "../ui/PopupForm";
import { Link } from "react-router-dom";
import RedHeader from "../ui/RedBgTitleHeader";
import LightCard from "../card/LightCard";
import { TxtTitles } from "../../helpers/breadCrumbs";


const isFreeEventDate = async (eventDate) => {
	const response = await isFreeEventDateAPI(eventDate)
	return response.data
}


function EventsEdit() {
	const { t } = useTranslation();
	const params = useParams()
	const [state, dispatch] = useReducer(eventsReducer, INITIAL_STATE, undefined)
	const navigate = useNavigate();
	const location = useLocation()
	const returnPath = sessionStorage.getItem('project-current-return')

	useEffect(() => {
		const get_data_set_api = async () => {
			try {
				const response = await getEventsDataSetAPI(params.id)
				const data_set = response.data
				dispatch({
					type: "INITIAL_DATA",
					eventsDetails: data_set.eventsDetails,
					events: data_set.events,
					kzmProject: data_set.kzmProject,
					staff: data_set.staff,
					conductor: data_set.conductor,
					roomsList: data_set.rooms,
					locations: data_set.locations,
					details: data_set.details,
					t: t,
				})
			} catch (ex) {
				console.error("Failed to download data set.");
			}
		}
		get_data_set_api()
	}, [])

	useEffect(() => {
		return () => sessionStorage.removeItem('project-current-return')
	}, [location])

	useEffect(() => {
		if (state.details) {
			if (state.eventsDetails.length === 0) {
				addEventCountView()
			}
		}
	}, [state.details]);

	const changeDetailsHandler = async (val, fieldName, eventDetailKey) => {
		const evDetailCopy = structuredClone(state.eventsDetails);
		const elementChange = evDetailCopy.find(
			el => el.key === eventDetailKey
		)

		if (elementChange) {
			elementChange.isFree = true
			elementChange.noFreeLinks = ''

			if (fieldName !== 'eventLength') {
				elementChange[fieldName] = val
			}

			if (fieldName === "startTime" || fieldName === "endTime") {
				const duration = diffTime(elementChange["startTime"], elementChange["endTime"])
				elementChange["eventLength"] = duration
			}

			if (fieldName === 'location') {
				elementChange.room = ""
			}
			// usun elem z tablicy i wstaw zmieniony
			const indexElem = evDetailCopy.findIndex(el => el.key === eventDetailKey)
			evDetailCopy.splice(indexElem, 1, elementChange)
			// check is free event date
			if (state.details && fieldName === 'eventDate' && elementChange['eventDate']) {
				elementChange.booked = await isFreeEventDate({
					event_date: val,
					calculation: params.key,
					action_type: "project-current",
				})
			}
			dispatch({type: "SET_EVENTS_DETAILS", dataset: evDetailCopy, key: "eventsDetails"})
		}
	};

	const addEventCountView = () => {
		const evDetails = []
		let key = "";

		Array.from(
			{ length: state.events.rehearsals },
			(_, index) => {
				key = uuidv4();
				const evDetailUnit = eventDetailUnit(key, "rehearsals", state.kzmProject);
				evDetails.push(evDetailUnit);
			}
		);
		Array.from(
			{ length: state.events.raccords },
			(_, index) => {
				key = uuidv4();
				const evDetailUnit = eventDetailUnit(key, "raccords", state.kzmProject);
				evDetails.push(evDetailUnit);
			}
		);
		Array.from(
			{ length: state.events.concerts },
			(_, index) => {
				key = uuidv4();
				const evDetailUnit = eventDetailUnit(key, "concerts", state.kzmProject);
				evDetails.push(evDetailUnit);
			}
		);
		dispatch({type: "SET_EVENTS_DETAILS", dataset: evDetails, key: "eventsDetails"})
	}

	const changeEventsHandler = (val, fieldName) => {
		if (integerValidate(val)) {
			const newEntry = {
				...state.events,
				[fieldName]: val,
			};
			dispatch({type: "SET_EVENTS", dataset: newEntry, key: "events"})

			if (state.details) {
				const newEntry = _.cloneDeep(state.eventsDetails);
				newEntry.unshift(eventDetailUnit(uuidv4(), fieldName, state.kzmProject));
				dispatch({type: "SET_EVENTS_DETAILS", dataset: newEntry, key: "eventsDetails"})
			}
		}
	};

	const changeDetailsView = () => dispatch({type: "SET_DETAILS", dataset: true, key: "details"})

	const buttonHandler = async (opt) => {
		if (opt === 'save') {
			dispatch({
				type: "SET_POPUP",
				dataset: {
					show: true,
					variant: "editF",
					title: t("popups.current_projects.save_data_title"),
					message: "popups.current_projects.save_data_message",
					type: "formular",
					leftBtn: t("common.button.save"),
					rightBtn: t("common.button.cancel"),
				},
				key: "popup"
			})
			return
		}
		else if (returnPath) navigate(returnPath);
		navigate("/projects/current/" + params.id)
	}

	const handlePopup = async (opt) => {
		if (opt.type === 'save') {
			const stateCopy = structuredClone(state)
			delete stateCopy.popup
			delete stateCopy.staff
			delete stateCopy.roomsList
			delete stateCopy.locations
			delete stateCopy.compositionOptions

			const response = await saveEventsAPI(params.id, stateCopy)
			if (response.status === 201) {
				dispatch({
					type: "SET_POPUP",
					dataset: {
						show: true,
						variant: "success",
						title: t("popups.save_data.title"),
						message: "popups.save_data.message",
						type: "formular",
						okBtn: t("common.button.ok"),
					},
					key: "popup"
				})
			}
			return
		} else {
			if (returnPath) navigate(returnPath);
			navigate("/projects/current/"+params.id)
		}
	}

	return (<>
		{state.popup.show
			? <PopupForm
				handlePopup={handlePopup}
				variant={state.popup.variant}
				title={t(state.popup.title)}
				message={t(state.popup.message)}
				leftBtn={state.popup.leftBtn}
				rightBtn={state.popup.rightBtn}
				okBtn={state.popup.okBtn}
				// context={state.popup.context}
			/>
			: <>
				<DarkCard classNames='mb-3 row'>
					<p className="m-0 p-0 breadcrumbs">
						<span className="txt">{t("menu.projects",{ ns: 'menu' })}</span>&#8201;&#9656;&#8201;
						<Link to={'/projects/currents-list'}>{t("menu.current_projects",{ ns: 'menu' })}</Link>&#8201;&#9656;&#8201;
						<Link to={'/projects/current/'+params.id}>{t("breadcrumbs.project_title")} P{params.id}</Link>&#8201;&#9656;&#8201;
						<span className="txt">{t("common.button.edit_events")}</span>
					</p>
				</DarkCard>
				<DarkCard classNames='mb-3 row'>
					<TxtTitles>{t("project.project_name_title")}</TxtTitles>
					<h1 className='mb-3 mt-0 p-0' style={{marginTop: '-5px'}}>
						{location.state.datasetName}
					</h1>

					<LightCard>
						<RedHeader title={t('project.events_title')}/>
						<div className='row px-2'>
							<div className='col-sm-6 col-md-4'>
								<div className='d-flex flex-row align-items-center my-1'>
									<div>
										{state.events.rehearsals || null } {t("events.rehearsals")}
									</div>
									<div className='ms-3'>
										<EventsTypesCount
											evValue={state.events.rehearsals}
											type={"rehearsals"}
											changeHandler={changeEventsHandler}
											moreDetails={state.details}
										/>
									</div>
								</div>
							</div>
							<div className='col-sm-6 col-md-4'>
								<div className='d-flex flex-row align-items-center my-1'>
									<div>
										{state.events.raccords || null} {t("events.raccords")}
									</div>
									<div className='ms-3'>
										<EventsTypesCount
											evValue={state.events.raccords}
											type={"raccords"}
											changeHandler={changeEventsHandler}
											moreDetails={state.details}
										/>
									</div>
								</div>
							</div>
							<div className='col-sm-6 col-md-4'>
								<div className='d-flex flex-row align-items-center my-1'>
									<div>
										{state.events.concerts || null} {t("events.concerts")}
									</div>
									<div className='ms-3'>
										<EventsTypesCount
											evValue={state.events.concerts}
											type={"concerts"}
											changeHandler={changeEventsHandler}
											moreDetails={state.details}
										/>
									</div>
								</div>
							</div>
						</div>
				
						{state.details ? null : (
							<div className='row px-2 mt-4'>
								<div className='addGroup'>
									<LordIcon
										url='cross'
										color={`${Colors.red};`}
										rotate='45'
										target='.addGroup'
										changeActive={changeDetailsView}
									/>
									<a className='ps-2' onClick={changeDetailsView}>
										{t("common.button.add_more_details")}
									</a>
								</div>
							</div>
						)}

						{state.details ? (
							<>
								<div className='row mt-3 px-2'>
									<div className="col">
										{state.eventsDetails.map(val =>
											<EventEntry
												key={val.key}
												eventDetail={val}
												dispatch={dispatch}
												changeDetailsHandler={changeDetailsHandler}
												staff={state.staff}
												compositionOptions={state.compositionOptions}
												kzmProject={state.kzmProject}
												locations={state.locations}
												roomsOptions={state.roomsList}
												conductor={state.conductor}
											/>)
										}
									</div>
								</div>
							</>
						) : null}
					</LightCard>

					<div className="mt-3">
						<Button
							className='me-4'
							variant='round'
							style={{backgroundColor: `${Colors.green}`}}
							name='save'
							onClick={() => buttonHandler('save')}>
							{t("common.button.save")}
						</Button>

						<Button
							className='me-4'
							variant='round'
							styling="bordered"
							name='cancel'
							onClick={() => buttonHandler('cancel')}>
							{t("common.button.cancel")}
						</Button>
					</div>
				</DarkCard>
			</>}
	</>);
}


export default EventsEdit;
